import { createUseInfiniteQuery, createUseMutation, createUseQuery } from "eddev/hooks";
import {
  UseAccountDetailsQuery,
  UseAddCouponMutation,
  UseAddCouponMutationVariables,
  UseAddressCountryDataQuery,
  UseAddToCartMutation,
  UseAddToCartMutationVariables,
  UseAdminAwardEntryMutationMutation,
  UseAdminAwardEntryMutationMutationVariables,
  UseAdminAwardEntryQuery,
  UseAdminAwardEntryQueryVariables,
  UseAdminJudgeYearsQuery,
  UseAwardForceAccountQuery,
  UseAwardForceEntriesQuery,
  UseAwardForceTransferMutation,
  UseAwardForceTransferMutationVariables,
  UseAwardShowcaseQuery,
  UseAwardShowcaseQueryVariables,
  UseBranchesQuery,
  UseBusinessTeamInviteByHashQuery,
  UseBusinessTeamInviteByHashQueryVariables,
  UseCancelBusinessInviteMutation,
  UseCancelBusinessInviteMutationVariables,
  UseCancelMyMembershipMutation,
  UseCancelMyMembershipMutationVariables,
  UseCartIntentQuery,
  UseCartQuery,
  UseChangePasswordMutation,
  UseChangePasswordMutationVariables,
  UseChangePaymentMethodMutation,
  UseChangePaymentMethodMutationVariables,
  UseCheckoutMutation,
  UseCheckoutMutationVariables,
  UseCreateNewPaymentMethodIntentMutation,
  UseCreateNewPaymentMethodIntentMutationVariables,
  UseCreateNewPaymentMethodMutation,
  UseCreateNewPaymentMethodMutationVariables,
  UseEmptyCartMutation,
  UseEmptyCartMutationVariables,
  UseEventTicketsQuery,
  UseEventTicketsQueryVariables,
  UseExpertiseQuery,
  UseFillCartMutation,
  UseFillCartMutationVariables,
  UseFinishResetPasswordMutation,
  UseFinishResetPasswordMutationVariables,
  UseInfiniteArticleSearchQuery,
  UseInfiniteArticleSearchQueryVariables,
  UseInfiniteAwardShowcaseQuery,
  UseInfiniteAwardShowcaseQueryVariables,
  UseInfiniteClassifiedSearchQuery,
  UseInfiniteClassifiedSearchQueryVariables,
  UseInfiniteDesignerDirectoryQuery,
  UseInfiniteDesignerDirectoryQueryVariables,
  UseInfiniteEventSearchQuery,
  UseInfiniteEventSearchQueryVariables,
  UseInviteBusinessMemberMutation,
  UseInviteBusinessMemberMutationVariables,
  UseJuryQuery,
  UseJuryQueryVariables,
  UseLeaveBusinessTeamMutation,
  UseLinkedMemberNumbersQuery,
  UseLoginMutation,
  UseLoginMutationVariables,
  UseMemberStatusQuery,
  UseMyBillingQuery,
  UseMyBusinessProfileQuery,
  UseMyInfoMutationMutation,
  UseMyInfoMutationMutationVariables,
  UseMyInfoQuery,
  UseMyMembershipQuery,
  UseMyOrdersQuery,
  UseMyPastAwardsQuery,
  UseMyPaymentMethodsQuery,
  UseMyProfileQuery,
  UseMySubscriptionsQuery,
  UseNewsletterSubscribeMutation,
  UseNewsletterSubscribeMutationVariables,
  UseOrderQuery,
  UseOrderQueryVariables,
  UseOwnedBusinessTeamQuery,
  UsePrepareSavedPaymentMethodMutation,
  UsePrepareSavedPaymentMethodMutationVariables,
  UseReactivateSubscriptionMutation,
  UseReactivateSubscriptionMutationVariables,
  UseRedeemTeamInviteMutation,
  UseRedeemTeamInviteMutationVariables,
  UseRefreshAuthTokenMutation,
  UseRefreshAuthTokenMutationVariables,
  UseRegisterCustomerMutation,
  UseRegisterCustomerMutationVariables,
  UseRemoveBusinessMemberMutation,
  UseRemoveBusinessMemberMutationVariables,
  UseRemoveItemsFromCartMutation,
  UseRemoveItemsFromCartMutationVariables,
  UseRemovePaymentMethodMutation,
  UseRemovePaymentMethodMutationVariables,
  UseResetPasswordMutation,
  UseResetPasswordMutationVariables,
  UseSessionTokenQuery,
  UseSetDefaultPaymentMethodMutation,
  UseSetDefaultPaymentMethodMutationVariables,
  UseSiteSearchQuery,
  UseSiteSearchQueryVariables,
  UseStudioQuery,
  UseStudioQueryVariables,
  UseUpdateAccountMutation,
  UseUpdateAccountMutationVariables,
  UseUpdateBusinessProfileMutation,
  UseUpdateBusinessProfileMutationVariables,
  UseUpdateCartItemQuantitiesMutation,
  UseUpdateCartItemQuantitiesMutationVariables,
  UseUpdateMyBillingMutation,
  UseUpdateMyBillingMutationVariables,
  UseUpdateProfileImagesMutation,
  UseUpdateProfileImagesMutationVariables,
  UseUpdateProfileMutation,
  UseUpdateProfileMutationVariables,
  UseUpdateTeamNameMutation,
  UseUpdateTeamNameMutationVariables,
  UseValidatePasswordMutation,
  UseValidatePasswordMutationVariables,
  UseVerifyMemberNumberMutation,
  UseVerifyMemberNumberMutationVariables,
} from "../types.graphql";

/**
 * DO NOT EDIT
 * This file is automatically generated by eddev
 * Any changes will be overwritten
 */

export const useInfiniteArticleSearch = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteArticleSearchQuery["articles"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteArticleSearchQueryVariables
>({
  name: "articles/UseInfiniteArticleSearch",
  defaultLimit: 8,
  paths: {
    "nodesPath": ["articles", "nodes"],
    "pageInfoPath": ["articles", "pageInfo"],
    "endCursorPath": ["articles", "pageInfo", "endCursor"],
    "hasNextPagePath": ["articles", "pageInfo", "hasNextPage"],
  },
});

export const useAdminAwardEntry = createUseQuery<UseAdminAwardEntryQuery, UseAdminAwardEntryQueryVariables>({
  name: "awards/admin/UseAdminAwardEntry",
});

export const useAdminAwardEntryMutation = createUseMutation<
  UseAdminAwardEntryMutationMutation,
  UseAdminAwardEntryMutationMutationVariables
>({ name: "awards/admin/UseAdminAwardEntryMutation" });

export const useAdminJudgeYears = createUseQuery<UseAdminJudgeYearsQuery, undefined>({
  name: "awards/admin/UseAdminJudgeYears",
});

export const useAwardShowcase = createUseQuery<UseAwardShowcaseQuery, UseAwardShowcaseQueryVariables>({
  name: "awards/UseAwardShowcase",
});

export const useInfiniteAwardShowcase = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteAwardShowcaseQuery["awardEntries"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteAwardShowcaseQueryVariables
>({
  name: "awards/UseInfiniteAwardShowcase",
  defaultLimit: 8,
  paths: {
    "nodesPath": ["awardEntries", "nodes"],
    "pageInfoPath": ["awardEntries", "pageInfo"],
    "endCursorPath": ["awardEntries", "pageInfo", "endCursor"],
    "hasNextPagePath": ["awardEntries", "pageInfo", "hasNextPage"],
  },
});

export const useJury = createUseQuery<UseJuryQuery, UseJuryQueryVariables>({ name: "awards/UseJury" });

export const useStudio = createUseQuery<UseStudioQuery, UseStudioQueryVariables>({ name: "awards/UseStudio" });

export const useAddCoupon = createUseMutation<UseAddCouponMutation, UseAddCouponMutationVariables>({
  name: "cart/UseAddCoupon",
});

export const useAddToCart = createUseMutation<UseAddToCartMutation, UseAddToCartMutationVariables>({
  name: "cart/UseAddToCart",
});

export const useCart = createUseQuery<UseCartQuery, undefined>({ name: "cart/UseCart" });

export const useCartIntent = createUseQuery<UseCartIntentQuery, undefined>({ name: "cart/UseCartIntent" });

export const useCheckout = createUseMutation<UseCheckoutMutation, UseCheckoutMutationVariables>({
  name: "cart/UseCheckout",
});

export const useEmptyCart = createUseMutation<UseEmptyCartMutation, UseEmptyCartMutationVariables>({
  name: "cart/UseEmptyCart",
});

export const useFillCart = createUseMutation<UseFillCartMutation, UseFillCartMutationVariables>({
  name: "cart/UseFillCart",
});

export const useOrder = createUseQuery<UseOrderQuery, UseOrderQueryVariables>({ name: "cart/UseOrder" });

export const usePrepareSavedPaymentMethod = createUseMutation<
  UsePrepareSavedPaymentMethodMutation,
  UsePrepareSavedPaymentMethodMutationVariables
>({ name: "cart/UsePrepareSavedPaymentMethod" });

export const useRemoveItemsFromCart = createUseMutation<
  UseRemoveItemsFromCartMutation,
  UseRemoveItemsFromCartMutationVariables
>({ name: "cart/UseRemoveItemsFromCart" });

export const useUpdateCartItemQuantities = createUseMutation<
  UseUpdateCartItemQuantitiesMutation,
  UseUpdateCartItemQuantitiesMutationVariables
>({ name: "cart/UseUpdateCartItemQuantities" });

export const useInfiniteClassifiedSearch = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteClassifiedSearchQuery["classifieds"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteClassifiedSearchQueryVariables
>({
  name: "classifieds/UseInfiniteClassifiedSearch",
  defaultLimit: 4,
  paths: {
    "nodesPath": ["classifieds", "nodes"],
    "pageInfoPath": ["classifieds", "pageInfo"],
    "endCursorPath": ["classifieds", "pageInfo", "endCursor"],
    "hasNextPagePath": ["classifieds", "pageInfo", "hasNextPage"],
  },
});

export const useEventTickets = createUseQuery<UseEventTicketsQuery, UseEventTicketsQueryVariables>({
  name: "events/UseEventTickets",
});

export const useInfiniteEventSearch = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteEventSearchQuery["events"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteEventSearchQueryVariables
>({
  name: "events/UseInfiniteEventSearch",
  defaultLimit: 4,
  paths: {
    "nodesPath": ["events", "nodes"],
    "pageInfoPath": ["events", "pageInfo"],
    "endCursorPath": ["events", "pageInfo", "endCursor"],
    "hasNextPagePath": ["events", "pageInfo", "hasNextPage"],
  },
});

export const useBranches = createUseQuery<UseBranchesQuery, undefined>({ name: "find-a-designer/UseBranches" });

export const useExpertise = createUseQuery<UseExpertiseQuery, undefined>({ name: "find-a-designer/UseExpertise" });

export const useInfiniteDesignerDirectory = createUseInfiniteQuery<
  Exclude<Exclude<UseInfiniteDesignerDirectoryQuery["directorySearch"], undefined | null>["nodes"], undefined | null>,
  UseInfiniteDesignerDirectoryQueryVariables
>({
  name: "find-a-designer/UseInfiniteDesignerDirectory",
  defaultLimit: 16,
  paths: {
    "nodesPath": ["directorySearch", "nodes"],
    "pageInfoPath": ["directorySearch", "pageInfo"],
    "endCursorPath": ["directorySearch", "pageInfo", "endCursor"],
    "hasNextPagePath": ["directorySearch", "pageInfo", "hasNextPage"],
  },
});

export const useSiteSearch = createUseQuery<UseSiteSearchQuery, UseSiteSearchQueryVariables>({
  name: "search/UseSiteSearch",
});

export const useAwardForceAccount = createUseQuery<UseAwardForceAccountQuery, undefined>({
  name: "users/awards/UseAwardForceAccount",
});

export const useAwardForceEntries = createUseQuery<UseAwardForceEntriesQuery, undefined>({
  name: "users/awards/UseAwardForceEntries",
});

export const useAwardForceTransfer = createUseMutation<
  UseAwardForceTransferMutation,
  UseAwardForceTransferMutationVariables
>({ name: "users/awards/UseAwardForceTransfer" });

export const useMyPastAwards = createUseQuery<UseMyPastAwardsQuery, undefined>({
  name: "users/awards/UseMyPastAwards",
});

export const useBusinessTeamInviteByHash = createUseQuery<
  UseBusinessTeamInviteByHashQuery,
  UseBusinessTeamInviteByHashQueryVariables
>({ name: "users/business-membership/UseBusinessTeamInviteByHash" });

export const useCancelBusinessInvite = createUseMutation<
  UseCancelBusinessInviteMutation,
  UseCancelBusinessInviteMutationVariables
>({ name: "users/business-membership/UseCancelBusinessInvite" });

export const useInviteBusinessMember = createUseMutation<
  UseInviteBusinessMemberMutation,
  UseInviteBusinessMemberMutationVariables
>({ name: "users/business-membership/UseInviteBusinessMember" });

export const useLeaveBusinessTeam = createUseMutation<UseLeaveBusinessTeamMutation, undefined>({
  name: "users/business-membership/UseLeaveBusinessTeam",
});

export const useOwnedBusinessTeam = createUseQuery<UseOwnedBusinessTeamQuery, undefined>({
  name: "users/business-membership/UseOwnedBusinessTeam",
});

export const useRedeemTeamInvite = createUseMutation<UseRedeemTeamInviteMutation, UseRedeemTeamInviteMutationVariables>(
  { name: "users/business-membership/UseRedeemTeamInvite" },
);

export const useRemoveBusinessMember = createUseMutation<
  UseRemoveBusinessMemberMutation,
  UseRemoveBusinessMemberMutationVariables
>({ name: "users/business-membership/UseRemoveBusinessMember" });

export const useUpdateTeamName = createUseMutation<UseUpdateTeamNameMutation, UseUpdateTeamNameMutationVariables>({
  name: "users/business-membership/UseUpdateTeamName",
});

export const useChangePaymentMethod = createUseMutation<
  UseChangePaymentMethodMutation,
  UseChangePaymentMethodMutationVariables
>({ name: "users/payment-methods/UseChangePaymentMethod" });

export const useCreateNewPaymentMethod = createUseMutation<
  UseCreateNewPaymentMethodMutation,
  UseCreateNewPaymentMethodMutationVariables
>({ name: "users/payment-methods/UseCreateNewPaymentMethod" });

export const useCreateNewPaymentMethodIntent = createUseMutation<
  UseCreateNewPaymentMethodIntentMutation,
  UseCreateNewPaymentMethodIntentMutationVariables
>({ name: "users/payment-methods/UseCreateNewPaymentMethodIntent" });

export const useMyPaymentMethods = createUseQuery<UseMyPaymentMethodsQuery, undefined>({
  name: "users/payment-methods/UseMyPaymentMethods",
});

export const useRemovePaymentMethod = createUseMutation<
  UseRemovePaymentMethodMutation,
  UseRemovePaymentMethodMutationVariables
>({ name: "users/payment-methods/UseRemovePaymentMethod" });

export const useSetDefaultPaymentMethod = createUseMutation<
  UseSetDefaultPaymentMethodMutation,
  UseSetDefaultPaymentMethodMutationVariables
>({ name: "users/payment-methods/UseSetDefaultPaymentMethod" });

export const useAccountDetails = createUseQuery<UseAccountDetailsQuery, undefined>({ name: "users/UseAccountDetails" });

export const useCancelMyMembership = createUseMutation<
  UseCancelMyMembershipMutation,
  UseCancelMyMembershipMutationVariables
>({ name: "users/UseCancelMyMembership" });

export const useChangePassword = createUseMutation<UseChangePasswordMutation, UseChangePasswordMutationVariables>({
  name: "users/UseChangePassword",
});

export const useFinishResetPassword = createUseMutation<
  UseFinishResetPasswordMutation,
  UseFinishResetPasswordMutationVariables
>({ name: "users/UseFinishResetPassword" });

export const useLinkedMemberNumbers = createUseQuery<UseLinkedMemberNumbersQuery, undefined>({
  name: "users/UseLinkedMemberNumbers",
});

export const useLogin = createUseMutation<UseLoginMutation, UseLoginMutationVariables>({ name: "users/UseLogin" });

export const useMemberStatus = createUseQuery<UseMemberStatusQuery, undefined>({ name: "users/UseMemberStatus" });

export const useMyBilling = createUseQuery<UseMyBillingQuery, undefined>({ name: "users/UseMyBilling" });

export const useMyBusinessProfile = createUseQuery<UseMyBusinessProfileQuery, undefined>({
  name: "users/UseMyBusinessProfile",
});

export const useMyInfo = createUseQuery<UseMyInfoQuery, undefined>({ name: "users/UseMyInfo" });

export const useMyInfoMutation = createUseMutation<UseMyInfoMutationMutation, UseMyInfoMutationMutationVariables>({
  name: "users/UseMyInfoMutation",
});

export const useMyMembership = createUseQuery<UseMyMembershipQuery, undefined>({ name: "users/UseMyMembership" });

export const useMyOrders = createUseQuery<UseMyOrdersQuery, undefined>({ name: "users/UseMyOrders" });

export const useMyProfile = createUseQuery<UseMyProfileQuery, undefined>({ name: "users/UseMyProfile" });

export const useMySubscriptions = createUseQuery<UseMySubscriptionsQuery, undefined>({
  name: "users/UseMySubscriptions",
});

export const useReactivateSubscription = createUseMutation<
  UseReactivateSubscriptionMutation,
  UseReactivateSubscriptionMutationVariables
>({ name: "users/UseReactivateSubscription" });

export const useRefreshAuthToken = createUseMutation<UseRefreshAuthTokenMutation, UseRefreshAuthTokenMutationVariables>(
  { name: "users/UseRefreshAuthToken" },
);

export const useRegisterCustomer = createUseMutation<UseRegisterCustomerMutation, UseRegisterCustomerMutationVariables>(
  { name: "users/UseRegisterCustomer" },
);

export const useResetPassword = createUseMutation<UseResetPasswordMutation, UseResetPasswordMutationVariables>({
  name: "users/UseResetPassword",
});

export const useSessionToken = createUseQuery<UseSessionTokenQuery, undefined>({ name: "users/UseSessionToken" });

export const useUpdateAccount = createUseMutation<UseUpdateAccountMutation, UseUpdateAccountMutationVariables>({
  name: "users/UseUpdateAccount",
});

export const useUpdateBusinessProfile = createUseMutation<
  UseUpdateBusinessProfileMutation,
  UseUpdateBusinessProfileMutationVariables
>({ name: "users/UseUpdateBusinessProfile" });

export const useUpdateMyBilling = createUseMutation<UseUpdateMyBillingMutation, UseUpdateMyBillingMutationVariables>({
  name: "users/UseUpdateMyBilling",
});

export const useUpdateProfile = createUseMutation<UseUpdateProfileMutation, UseUpdateProfileMutationVariables>({
  name: "users/UseUpdateProfile",
});

export const useUpdateProfileImages = createUseMutation<
  UseUpdateProfileImagesMutation,
  UseUpdateProfileImagesMutationVariables
>({ name: "users/UseUpdateProfileImages" });

export const useValidatePassword = createUseMutation<UseValidatePasswordMutation, UseValidatePasswordMutationVariables>(
  { name: "users/UseValidatePassword" },
);

export const useVerifyMemberNumber = createUseMutation<
  UseVerifyMemberNumberMutation,
  UseVerifyMemberNumberMutationVariables
>({ name: "users/UseVerifyMemberNumber" });

export const useAddressCountryData = createUseQuery<UseAddressCountryDataQuery, undefined>({
  name: "util/UseAddressCountryData",
});

export const useNewsletterSubscribe = createUseMutation<
  UseNewsletterSubscribeMutation,
  UseNewsletterSubscribeMutationVariables
>({ name: "util/UseNewsletterSubscribe" });
